import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FacilityAssetDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-facilityasset',
  templateUrl: './facilityasset.component.html',
  styleUrls: ['./facilityasset.component.scss']
})
export class FacilityAssetComponent implements OnInit {


  facilityassetForm: FormGroup;
  facilityassetFormArray: FormGroup;
  control = new FormControl();
  @Input() facilityassets: FacilityAssetDto[];
  @Input() routeAnimationsElements: any;
  @Output() facilityasset = new EventEmitter<FacilityAssetDto[]>()
  @Output() deleteFacilityAssetEvent = new EventEmitter<any>()

    selectedFacilityAsset: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnInit() {
      this.createFacilityAssetForm();
    }

    createFacilityAssetForm() {
      this.facilityassetForm = this.fb.group({
        FacilityAssetName: ['', Validators.required],
        FacilityCode: ['', Validators.required],
        id: null
        });
        this.facilityassetFormArray = this.fb.group({ FacilityAssets: this.fb.array([])
          });
        this.setFacilityAsset();
    }

  // method to display facilityassets
  setFacilityAsset() {
    const control  = this.facilityassetFormArray.controls.FacilityAssets as FormArray;
    this.facilityassets.forEach( e => {
      control.push(
        this.fb.group({
          FacilityAssetName: e.FacilityAssetName,
          FacilityCode:e.FacilityCode,
          id: e.id
        })
      );
    });
  }


  // method to add FacilityAsset
  addFacilityAsset(value: FacilityAssetDto) {
    const control  = this.facilityassetFormArray.controls.FacilityAssets as FormArray;
    control.insert(0,
          this.fb.group({
            FacilityAssetName: value.FacilityAssetName,
           FacilityCode: value.FacilityCode,
            id: null
          })
       );
  }

  selectFacilityAsset(value) {}

  // method to delete facilityasset from arrary list
  deleteFacilityAsset(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.facilityassetFormArray.controls.FacilityAssets as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.facilityassets.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.facilityassets[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: FacilityAssetDto) {
    if(this.facilityassetForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.facilityassetFormArray.get('FacilityAssets')['controls'][this.selectedIndex].patchValue({FacilityAssetName: formValue.FacilityAssetName, FacilityCode:formValue.FacilityCode});
    } else {
      this.addFacilityAsset(formValue);
    }
    this.selectedIndex = null;
    this.facilityassetForm.reset()
  }

  onEdit(index, value: FacilityAssetDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.facilityassetForm.patchValue({FacilityAssetName: value.FacilityAssetName});
    this.facilityassetForm.patchValue({FacilityCode: value.FacilityCode});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.facilityassetForm.reset();
  }

  onSubmit(formValue: FacilityAssetDto[]) {
  this.facilityasset.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteFacilityAssetEvent.emit(this.filteredDelete);
  }
  }

}
